export interface EnvironmentBase {
  production: boolean;
  chatHubUrl: string;
  securityTokenService: string;
  oidcClientId: string;
  oidcScope: string;
  supportPortalUrl: string;
}

export const environmentBase: Omit<EnvironmentBase, 'production'> = {
  chatHubUrl: '',
  securityTokenService: '',
  oidcClientId: '',
  oidcScope: '',
  supportPortalUrl: '',
};

/**
 * Merges the runtime config file over the compiled defaults.
 *
 * Throws when the file cannot be read: every environment-specific value comes
 * from it, so there is no usable fallback.
 */
export async function applyRuntimeConfig(
  environment: EnvironmentBase,
): Promise<void> {
  const path = environment.production
    ? 'assets/config/config.json'
    : 'assets/config/config.development.json';

  const response = await fetch(path, { cache: 'no-cache' });

  if (!response.ok) {
    throw new Error(`palchat: ${path} returned ${response.status}`);
  }

  Object.assign(environment, await response.json());
}
